import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { YPMCONNECTORVService } from './api/yPMCONNECTORV.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ConnectorApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ConnectorApiModule> {
        return {
            ngModule: ConnectorApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ConnectorApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ConnectorApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
